import { Box, Button, Paper, Typography } from '@mui/material';

export interface StuckReport { id: number; uuid: string; facility_name: string; status: string; minutes: number }
export interface WorkerStatus { stuck: StuckReport[]; stuck_after_minutes: number; last_generation_started_at: string | null }

/** Red strip when reports have sat in pending/running past the watchdog window. */
export default function WorkerBanner({ worker, onRequeue }: { worker: WorkerStatus | null; onRequeue: (uuid: string) => void }) {
  if (!worker || worker.stuck.length === 0) return null;
  return (
    <Paper variant="outlined" square sx={{ mb: 2, p: 1.5, borderColor: '#B31B1B', bgcolor: '#FFF5F5' }}>
      <Typography variant="body2" sx={{ fontWeight: 700, color: '#B31B1B' }}>
        {worker.stuck.length} report{worker.stuck.length === 1 ? '' : 's'} stuck over {worker.stuck_after_minutes} minutes. The worker may be down.
      </Typography>
      {worker.stuck.map((r) => (
        <Box key={r.uuid} sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: 0.5 }}>
          <Typography variant="body2">#{r.id} {r.facility_name} · {r.status} {r.minutes} min</Typography>
          <Button size="small" onClick={() => onRequeue(r.uuid)}>Requeue</Button>
        </Box>
      ))}
    </Paper>
  );
}
